require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-campaign-orientacion-sexual-y-genero.json") })
        }
      }, "path---es-mx-campaign-orientacion-sexual-y-genero");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-campaign-orientacion-sexual-y-genero!./.cache/json/es-mx-campaign-orientacion-sexual-y-genero.json
// module id = 886
// module chunks = 231608221292675